import LINK_CONFIG from './env';

/**
 * Builds the Amplify configuration used for the ERP portal integration. Spreads the environment's AWS exports, enables ssr and overrides the OAuth sign-in and sign-out redirects with the configured link.
 *
 * @returns Amplify configuration object for the ERP portal.
 */
const updatedAwsConfig = () => ({
  ...LINK_CONFIG.AWS_CONFIG,
  ssr: true,
  oauth: {
    ...LINK_CONFIG.AWS_CONFIG.oauth,
    redirectSignIn: LINK_CONFIG.LINK_REDIRECT_AWS,
    redirectSignOut: LINK_CONFIG.LINK_REDIRECT_AWS,
  },
});

export default updatedAwsConfig;
